module.exports = __webpack_public_path__ + "img/cloud-done-outline.3a0cb81e.svg";